module.exports = __webpack_public_path__ + "static/media/boleto.9dd27643.svg";